import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "editPharmacy" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Title = _resolveComponent("Title")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_AddInfo = _resolveComponent("AddInfo")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_ServiceRequest = _resolveComponent("ServiceRequest")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_Title, {
        title: _ctx.$t('pharmacyInformation')
      }, null, 8, ["title"]),
      _createVNode(_component_FormKit, {
        type: "form",
        id: "pharmacyForm",
        modelValue: _ctx.formData,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData) = $event)),
        actions: false,
        onSubmit: _ctx.submitHandler
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoOfPharmacy, (el) => {
            return (_openBlock(), _createBlock(_component_Input, {
              key: el.id,
              type: el.type,
              name: el.name,
              label: _ctx.$t(el.label),
              validation: el.validation,
              validationMessages: {
          required: _ctx.$t('validation.required')
        },
              disabled: _ctx.disabledInput(el.name),
              "data-testid": el.dataTestId
            }, null, 8, ["type", "name", "label", "validation", "validationMessages", "disabled", "data-testid"]))
          }), 128)),
          _createVNode(_component_Dropdown, {
            class: "infoOfPharmacy-dropdown",
            selectedOption: _ctx.langsDropdown.selectedOption,
            options: _ctx.langsDropdown.options,
            label: _ctx.$t('chooseLanguage'),
            multiple: true,
            onSelectOption: _ctx.selectLanguage
          }, null, 8, ["selectedOption", "options", "label", "onSelectOption"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoOfDeliveries, (el) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "block-input",
              key: el.id
            }, [
              _createVNode(_component_Input, {
                type: el.type,
                name: el.name,
                label: _ctx.$t(el.label),
                disabled: _ctx.disabledInput(el.name),
                "data-testid": el.dataTestId
              }, null, 8, ["type", "name", "label", "disabled", "data-testid"]),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('daysDelivery')), 1)
            ]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoEmail, (el) => {
            return (_openBlock(), _createBlock(_component_Input, {
              key: el.id,
              type: el.type,
              name: el.name,
              label: _ctx.$t(el.label),
              validation: el.validation,
              validationMessages: {
          required: _ctx.$t('validation.required'),
          email: _ctx.$t('validation.email')
        },
              "data-testid": el.dataTestId
            }, null, 8, ["type", "name", "label", "validation", "validationMessages", "data-testid"]))
          }), 128)),
          _createVNode(_component_FormKit, {
            type: "group",
            name: "additionalEmails"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailItems, (el, idx) => {
                return (_openBlock(), _createBlock(_component_Input, {
                  key: el,
                  name: el,
                  id: el,
                  label: _ctx.$t('alarmEmail'),
                  validation: 'required|email',
                  validationMessages: {
            required: _ctx.$t('validation.required'),
            email: _ctx.$t('validation.email')
          },
                  disabled: !_ctx.user?.role.permissions.pharmacy.update,
                  onCloseInput: _ctx.removeEmailItem,
                  "data-testid": 'inputAddAlarmEmail' + idx
                }, null, 8, ["name", "id", "label", "validationMessages", "disabled", "onCloseInput", "data-testid"]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_AddInfo, {
            title: _ctx.$t('email'),
            onClick: _ctx.addEmailItem
          }, null, 8, ["title", "onClick"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoPhoneNumber, (el) => {
            return (_openBlock(), _createBlock(_component_Input, {
              key: el.id,
              type: el.type,
              name: el.name,
              label: _ctx.$t(el.label),
              validation: el.validation,
              "validation-visibility": el.validationVisibility,
              validationMessages: {
          matches: _ctx.$t('validation.phoneNumber'),
          required: _ctx.$t('validation.required')
        },
              disabled: !_ctx.user?.role.permissions.pharmacy.update,
              "data-testid": el.dataTestId
            }, null, 8, ["type", "name", "label", "validation", "validation-visibility", "validationMessages", "disabled", "data-testid"]))
          }), 128)),
          _createVNode(_component_FormKit, {
            type: "group",
            name: "additionalPhoneNumbers"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phoneItems, (el, idx) => {
                return (_openBlock(), _createBlock(_component_Input, {
                  key: el,
                  name: el,
                  id: el,
                  label: _ctx.$t('alarmPhoneNumber'),
                  validation: [['required'], ['matches', /^\+[0-9]{10,14}$/]],
                  "validation-visibility": "dirty",
                  validationMessages: {
            matches: _ctx.$t('validation.phoneNumber'),
            required: _ctx.$t('validation.required')
          },
                  disabled: !_ctx.user?.role.permissions.pharmacy.update,
                  onCloseInput: _ctx.removePhoneItem,
                  "data-testid": 'inputAddAlarmPhoneNumber' + idx
                }, null, 8, ["name", "id", "label", "validationMessages", "disabled", "onCloseInput", "data-testid"]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_AddInfo, {
            title: _ctx.$t('phoneNumber'),
            onClick: _ctx.addPhoneItem
          }, null, 8, ["title", "onClick"]),
          _createVNode(_component_Input, {
            type: "number",
            name: "shelvesNumber",
            label: _ctx.$t('shelvesNumber'),
            validation: "required",
            validationMessages: {
          required: _ctx.$t('validation.required')
        }
          }, null, 8, ["label", "validationMessages"])
        ]),
        _: 1
      }, 8, ["modelValue", "onSubmit"])
    ]),
    _createVNode(_component_Footer, {
      disabledMakeServiceRequest: _ctx.formData.serviceRequest,
      onCleanForm: _ctx.cleanForm,
      onSubmitForm: _ctx.submitForm,
      onOpenModalServiceRequest: _ctx.openModal
    }, null, 8, ["disabledMakeServiceRequest", "onCleanForm", "onSubmitForm", "onOpenModalServiceRequest"]),
    _createVNode(_component_ServiceRequest, {
      showModalServiceRequest: _ctx.showModalServiceRequest,
      onCloseModal: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModalServiceRequest = false)),
      onSaveServiceRequest: _ctx.saveServiceRequest
    }, null, 8, ["showModalServiceRequest", "onSaveServiceRequest"])
  ], 64))
}